var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{model:{value:(_vm.string),callback:function ($$v) {_vm.string=$$v},expression:"string"}})}
var staticRenderFns = []

export { render, staticRenderFns }